/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from "react";
import queryString from "query-string";

import LoginForm from "./loginForm";
import { useLocalization } from "../../containers/I18nProvider";
import RequestLoginErrorMessage from "../../components/RequestLoginErrorMessage";
import ServiceApi from "../../services/ServiceApi";

import "bootstrap/dist/css/bootstrap.css";
import "./style.scss";
import logo from "./img/logo.png";
import Helmet from 'react-helmet';

const Login = (props) => {
  const { translate, changeDefaultLocale, changeLocalePath } = useLocalization();
  const api = new ServiceApi();
  const parameters = queryString.parse(props.location.search);

  useEffect(() => {
    document.title = translate("PlayHubLogin");
    changeDefaultLocale('pt-BR');

    changeLocalePath('/lang/playHub');
  }, [translate, changeDefaultLocale, changeLocalePath]);

  const validateParams = () => {
    if (
      !parameters.client_id ||
      !parameters.redirect_uri ||
      !parameters.response_type
    ) {
      return false;
    }
    return true;
  };

  return (
    <div className="container-fluid login">
      <Helmet>
        <link rel="icon" type="image/png" href={logo} sizes="16x16" />
      </Helmet>
      <div className="d-flex flex-row justify-content-center">
        <div className="container">
          <div className="row">
            <div className="col"></div>
            <div className="col login-content">
              <div className="login-logo">
                <img
                  className="logo-play-hub"
                  src={logo}
                  alt="playhub"
                  width="213"
                  height="43"
                />
              </div>
              {validateParams() ? (
                <LoginForm api={api} location={props.location} />
              ) : (
                <RequestLoginErrorMessage
                  onlyMessage={true}
                  message={translate("RequestLoginErrorMessage")}
                />
              )}
            </div>
            <div className="col"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
